module.exports = __webpack_public_path__ + "img/img31.a3ab9e63.png";